import type { ISbStoriesParams } from '@storyblok/js';
import type { ComputedRef } from 'vue';

type BlogBaseParams = Pick<ISbStoriesParams, 'content_type' | 'version' | 'resolve_links' | 'resolve_relations' | 'language' | 'filter_query'>;

export type UseStoryblokBlogApiParamsReturn = {
    blogApiOptions: ComputedRef<BlogBaseParams>;
};

export const useStoryblokBlogApiParams = (categoryIds?: MaybeRefOrGetter<string[] | undefined>): UseStoryblokBlogApiParamsReturn => {
    const { apiOptions } = useStoryblokApiParams();

    return {
        blogApiOptions: computed(() => {
            const ids = toValue(categoryIds);

            return {
                ...apiOptions.value,
                content_type: 'storyblok-blog-post',
                resolve_relations: 'storyblok-blog-post.categories',
                ...(ids?.length ? { filter_query: { categories: { in: ids.join(',') } } } : {}),
            };
        }),
    };
};
